import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Button,
  List,
  ListItem,
  Box,
  Container,
  CircularProgress,
  Radio,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useLocation, useNavigate } from "react-router-dom";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../api_Routes";
import queryString from "query-string";
// import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Crtypto from "../../Assets/crypto.svg";
import Payeer from "../../Assets/Payeer.png";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import {PiHandDeposit} from "react-icons/pi";
import IconButton from "@mui/material/IconButton";
// import Paypal from "../../Assets/paypal.png";
import CloseIcon from "@mui/icons-material/Close";
import {useBalance} from "../../Context/BalanceContext";
import {useCenteredSnackbar} from "../../tools/useCenteredSnackbar";

const DomainInvoice = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { balance } = useBalance();
  const { invoice_id } = queryString.parse(location.search);
  const baseApi = api_Routes.SmmDomain.Invoice(invoice_id);
  const [invoice, setInvoice] = useState(null);
  const { enqueueSnackbar,closeSnackbar } = useSnackbar();
  const { showCenteredPopup } = useCenteredSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  // const [payPalError, setPayPalError] = useState("");
  // const [paypalReady, setPaypalReady] = useState(false);
  const invoiceRef = useRef(null);

  const action = key => (
      <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => closeSnackbar(key)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
  );
  // Fetch invoice data
  useEffect(() => {
    const getInvoice = async () => {
      try {
        const { response, message } = await Helper.Get({
          url: baseApi,
          hasToken: true,
        });

        if (response) {
          setInvoice({
            invoice_id: response.data.uuid,
            // discount: response.data.discount || 0,
            // count: response.data.count || 0,
            final_price: response.data.price,
            domain: response.data.domains.domain,
            domain_desc: response.data.domains.description,
            // service_type_name: response.data.service_type_name,
            user_name: response.data.user.name,
            price: response.data.price,
            // panel_url: response.data.panel_url,
            created_at: response.data.created_at,
            status: response.data.status,
          });
        } else {
          showCenteredPopup(message || "Failed to load invoice",
              { variant: "error",
                persist: true });
          // enqueueSnackbar(message || "Failed to load invoice", {
          //   variant: "error",
          //   persist: true,
          //   action,
          // });
        }
      } catch (error) {
        showCenteredPopup("Error loading invoice",
            { variant: "error",
              persist: true });
        // enqueueSnackbar("Error loading invoice", { variant: "error",
        //   persist: true,
        //   action, });
        console.error("Error fetching invoice:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getInvoice();
  }, [baseApi, enqueueSnackbar]);

  const printInvoice = () => {
    if (!invoiceRef.current) return;
    const printContent = invoiceRef.current.innerHTML;
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
  };

  const handleMethodChange = (event) => {
    setPaymentMethod(event.target.value);
    // setPayPalError("");
  };

  // Add this useEffect hook in your ServicesInvoice component
  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        const { response } = await Helper.Get({
          url: api_Routes.SmmDomain.Invoice(invoice_id),
          hasToken: true,
        });

        if (response?.data?.status_payment === "PAID") {
          showCenteredPopup("Payment completed successfully!",
              { variant: "success",
                persist: true });
          // enqueueSnackbar("Payment completed successfully!", {
          //   variant: "success",
          //   persist: true,
          //   action,
          // });
          navigate("/payment/success");
        }
      } catch (error) {
        console.error("Error checking payment status:", error);
      }
    };

    const interval = setInterval(checkPaymentStatus, 10000); // Check every 10 seconds
    return () => clearInterval(interval);
  }, [invoice_id, enqueueSnackbar, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!paymentMethod) {
      showCenteredPopup("Please select a payment method.",
          { variant: "warning",
            persist: true });
      // enqueueSnackbar("Please select a payment method.", {
      //   variant: "warning",
      //   persist: true,
      //   action,
      // });
      return;
    }
    // if (paymentMethod === "paypal") return;

    setIsProcessingPayment(true);
    try {
      const { response, message } = await Helper.Post({
        url: api_Routes.SmmDomain.pay,
        data: { payment_method: paymentMethod, invoice_id },
        hasToken: true,
      });

      if (response) {
        showCenteredPopup(message || "Payment initiated successfully",
            { variant: "success",
              persist: true });
        // enqueueSnackbar(message || "Payment initiated successfully", {
        //   variant: "success",
        //   persist: true,
        //   action,
        // });
        if (response.data) {
          window.location.href = response.data;
        }
      } else {
        throw new Error(message || "Payment initiation failed");
      }
    } catch (error) {
      showCenteredPopup(error.message,
          { variant: "error",
            persist: true });
      // enqueueSnackbar(error.message, { variant: "error" ,
      //   persist: true,
      //   action,});
      console.error("Payment error:", error);
    } finally {
      setIsProcessingPayment(false);
    }
  };

  const handleAddBalanceClick = async () => {

    navigate("/dashboard/deposit", { state: { from: location } });
  };

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!invoice) {
    return (
      <Container sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="h6">Invoice not found</Typography>
      </Container>
    );
  }

  if (invoice.status === "PAID") {
    return (
      <Container sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Invoice Already Paid
        </Typography>
        <Button variant="contained" onClick={printInvoice}>
          Print Invoice
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box
        ref={invoiceRef}
        sx={{
          bgcolor: "background.paper",
          p: { xs: 3, md: 4 },
          borderRadius: 2,
          boxShadow: 1,
        }}
      >
        {/* Invoice Header */}
        <Box sx={{ mb: 4, textAlign: "center" }}>
          <Typography variant="h4" gutterBottom>
            Order Invoice
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography>
              <strong>Invoice #:</strong> {invoice.invoice_id}
            </Typography>
            <Typography>
              <strong>Date:</strong> {invoice.created_at}
            </Typography>
          </Box>
        </Box>

        {/* From/To Sections */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 4,
            mb: 4,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom>
              From:
            </Typography>
            <Typography gutterBottom>
              <strong>BOOKSMM</strong>
            </Typography>
            <Typography>info@booksmm.com</Typography>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom>
              To:
            </Typography>
            <Typography gutterBottom>
              <strong>{invoice.user_name}</strong>
            </Typography>
          </Box>
        </Box>

        {/* Service Details */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            Domain Details
          </Typography>
          <Typography gutterBottom>
            <strong>{invoice.domain}</strong>
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 2 }}>
            <ListItem sx={{ display: "list-item", pl: 1 }}>
              {invoice.domain_desc}
            </ListItem>
          </List>
        </Box>

        {/* Price */}
        <Box
          sx={{
            bgcolor: "primary.main",
            color: "primary.contrastText",
            p: 2,
            mb: 4,
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography>
            <strong>Price:</strong>
          </Typography>
          <Typography>
            <strong>${invoice.price}</strong>
          </Typography>
        </Box>
        {/*<Box*/}
        {/*  sx={{*/}
        {/*    bgcolor: "primary.main",*/}
        {/*    color: "primary.contrastText",*/}
        {/*    p: 2,*/}
        {/*    mb: 4,*/}
        {/*    borderRadius: 1,*/}
        {/*    display: "flex",*/}
        {/*    justifyContent: "space-between",*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <Typography>*/}
        {/*    <strong>Discount:</strong>*/}
        {/*  </Typography>*/}
        {/*  <Typography>*/}
        {/*    <strong>${invoice.discount}</strong>*/}
        {/*  </Typography>*/}
        {/*</Box>*/}
        {/*<Box*/}
        {/*  sx={{*/}
        {/*    bgcolor: "primary.main",*/}
        {/*    color: "primary.contrastText",*/}
        {/*    p: 2,*/}
        {/*    mb: 4,*/}
        {/*    borderRadius: 1,*/}
        {/*    display: "flex",*/}
        {/*    justifyContent: "space-between",*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <Typography>*/}
        {/*    <strong>Final Price:</strong>*/}
        {/*  </Typography>*/}
        {/*  <Typography>*/}
        {/*    <strong>${invoice.final_price}</strong>*/}
        {/*  </Typography>*/}
        {/*</Box>*/}
        {/* Payment Methods */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            Payment Methods
          </Typography>
          <Typography paragraph>
            Please select one payment method below.
          </Typography>

          <Box sx={{ mb: 3 }}>
            {/*<Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>*/}
            {/*  <Radio*/}
            {/*    checked={paymentMethod === "cryptomus"}*/}
            {/*    onChange={handleMethodChange}*/}
            {/*    value="cryptomus"*/}
            {/*    color="primary"*/}
            {/*  />*/}
            {/*  <img*/}
            {/*    src={Crtypto}*/}
            {/*    alt="Cryptomus"*/}
            {/*    style={{ height: 24, marginRight: 8 }}*/}
            {/*  />*/}
            {/*  <Typography>Cryptomus</Typography>*/}
            {/*  /!*<Typography*!/*/}
            {/*  /!*    sx={{*!/*/}
            {/*  /!*      marginLeft:'10px',*!/*/}
            {/*  /!*      color:'#edaa0d',*!/*/}
            {/*  /!*      fontSize:'15px'*!/*/}
            {/*  /!*    }}*!/*/}
            {/*  /!*>*!/*/}
            {/*  /!*  (Get 5% off your entire invoice when you pay via Cryptomus.)*!/*/}
            {/*  /!*</Typography>*!/*/}
            {/*</Box>*/}

            {/*<Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>*/}
            {/*  <Radio*/}
            {/*      checked={paymentMethod === "paypal"}*/}
            {/*      onChange={handleMethodChange}*/}
            {/*      value="paypal"*/}
            {/*      color="primary"*/}
            {/*  />*/}
            {/*  <img src={Paypal} alt="PayPal" style={{ height: 24, marginRight: 8 }} />*/}
            {/*  <Typography>PayPal</Typography>*/}
            {/*</Box>*/}

            {/*<Box sx={{ display: "flex", alignItems: "center" }}>*/}
            {/*  <Radio*/}
            {/*    checked={paymentMethod === "payeer"}*/}
            {/*    onChange={handleMethodChange}*/}
            {/*    value="payeer"*/}
            {/*    color="primary"*/}
            {/*  />*/}
            {/*  <img*/}
            {/*    src={Payeer}*/}
            {/*    alt="Payeer"*/}
            {/*    style={{ height: 24, marginRight: 8 }}*/}
            {/*  />*/}
            {/*  <Typography>Payeer</Typography>*/}
            {/*  /!*<Typography*!/*/}
            {/*  /!*sx={{*!/*/}
            {/*  /!*  marginLeft:'10px',*!/*/}
            {/*  /!*  color:'#edaa0d',*!/*/}
            {/*  /!*  fontSize:'15px'*!/*/}
            {/*  /!*}}*!/*/}
            {/*  /!*>*!/*/}
            {/*  /!*  (Get 5% off your entire invoice when you pay via Payeer.)*!/*/}
            {/*  /!*</Typography>*!/*/}
            {/*</Box>*/}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Radio
                  checked={paymentMethod === "balance"}
                  onChange={handleMethodChange}
                  value="balance"
                  color="primary"
              />
              <PiHandDeposit style={{ height: 24, marginRight: 8 }} />
              <Typography>Balance</Typography>
              <Typography
                  sx={{
                    marginLeft:'10px',
                    color:'#edaa0d',
                    fontSize:'15px'
                  }}
              >
                Your Balance is {balance}$
                <span style={{
                  color:'#ff0000',
                  marginLeft:'10px'
                }}>
                  {invoice.final_price > balance ? "You Can't Buy With Blance Please Add Balance First" : ''}
                </span>
                <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      whiteSpace: "nowrap",
                      background: "#ECA601",
                      padding: "10px 10px",
                      marginLeft: '10px',
                      borderRadius: "10px",
                      // Adding inner shadow using a pseudo-element
                      color: "#F1F5FD",
                      position: "relative",
                      lineHeight: "10px",
                      overflow: "hidden",
                      fontWeight: "700",
                      fontSize: "12px",
                      boxShadow: "0px 3px 3px #00000040", // Outer shadow
                      "&:before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        borderRadius: "0 20px 20px 0",
                        background: "rgba(255, 255, 255, 0.1)", // Color for the inner shadow
                        filter: "blur(4px)",
                        zIndex: 1,
                      },
                      "&:hover:before": {
                        background: "rgba(255, 255, 255, 0.2)", // Darker on hover for inner shadow
                      },
                    }}
                    disabled={isLoading}
                    onClick={handleAddBalanceClick}
                >
                  {isLoading ? (
                      <CircularProgress size={22} sx={{ color: "white" }} />
                  ) : (
                      "Add Balance"
                  )}
                </Button>

              </Typography>
            </Box>
            {/*<Box sx={{ display: "flex", alignItems: "center" }}>*/}
            {/*  <Radio*/}
            {/*    checked={paymentMethod === "manually"}*/}
            {/*    onChange={handleMethodChange}*/}
            {/*    value="manually"*/}
            {/*    color="primary"*/}
            {/*  />*/}
            {/*  <AttachMoneyIcon style={{ height: 24, marginRight: 8 }} />*/}
            {/*  <Typography>Cash Payment (via Marketer)</Typography>*/}
            {/*</Box>*/}
          </Box>

          {/*{payPalError && (*/}
          {/*    <Typography color="error" sx={{ mb: 2 }}>{payPalError}</Typography>*/}
          {/*)}*/}

          {/*{paymentMethod === "paypal" && (*/}
          {/*    <Box sx={{*/}
          {/*      border: "1px solid #eee",*/}
          {/*      p: 2,*/}
          {/*      borderRadius: 1,*/}
          {/*      backgroundColor: "#f9f9f9"*/}
          {/*    }}>*/}
          {/*      <Typography variant="body2" color="textSecondary" gutterBottom>*/}
          {/*        Test with PayPal Sandbox:*/}
          {/*      </Typography>*/}
          {/*      <Typography variant="caption" display="block" gutterBottom>*/}
          {/*        Email: sb-abcdef123456@business.example.com*/}
          {/*      </Typography>*/}
          {/*      <Typography variant="caption" display="block" sx={{ mb: 2 }}>*/}
          {/*        Password: test1234*/}
          {/*      </Typography>*/}

          {/*      */}
          {/*    </Box>*/}
          {/*)}*/}
        </Box>

        {/* Action Buttons */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button
            variant="outlined"
            onClick={printInvoice}
            sx={{ "@media print": { display: "none" } }}
          >
            Print Invoice
          </Button>

          {paymentMethod && (
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={isProcessingPayment}
              sx={{ "@media print": { display: "none" } }}
            >
              {isProcessingPayment ? (
                <>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Processing...
                </>
              ) : (
                "Buy Now"
              )}
            </Button>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default DomainInvoice;
